module.exports = __webpack_public_path__ + "assets/images/gli_g.ea94a4df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/gli_g.png
// module id = 717
// module chunks = 1